import AOS from 'aos/dist/aos.js';
import '../sass/styles.scss';
import 'jquery/dist/jquery.js';
import 'slick-carousel/slick/slick.js';
import 'aos/dist/aos.js';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm';
import 'jquery-zoom/jquery.zoom.min.js';

$ = jQuery


$(document).ready(function(){
        //Reduce Header
        const header = document.querySelector("header");
        
        window.addEventListener('scroll', () => (window.scrollY > 200) ? header.classList.add('reduce_header') :  header.classList.remove('reduce_header')  );
        
        const navigator = document.querySelector("nav");
        document.querySelector(".nav-btn").addEventListener("click", ()=> navigator.classList.add('show'));
        document.querySelector(".close-menu").addEventListener("click", ()=> navigator.classList.remove('show'));
        
        window.addEventListener('resize', () => navigator.classList.remove('show'));


        Fancybox.bind('[data-fancybox="gallery"]', {

                Thumbs: {
                        showOnStart: true,
                },

        });

        Fancybox.bind('[data-fancybox=""]', {

                Thumbs: {
                        showOnStart: true,
                },

        });


              
        
        AOS.init();
        window.addEventListener('load', AOS.refresh);


        $('.slider2').slick({
                dots: false,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true

        });
        
        $(".slide-comments .left2").click( () => {
                $(".slider2").slick('slickPrev');
        });

        $(".slide-comments .right2").click( () => {
                $(".slider2").slick('slickNext');
        });

        $('.slider3').slick({
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                adaptiveHeight: true

        });
        
        $(".carousel-dots .left3").click( () => {
                $(".slider3").slick('slickPrev');
        });

        $(".carousel-dots .right3").click( () => {
                $(".slider3").slick('slickNext');
        });
        

});


// $(document).ready(function(){
// 	$('.banner').zoom();
// });




